document.documentElement.classList.remove('no-js');

/* These must be defined before anything else runs: several product-page
   features (the pricing-list table, size-breakdown summary) call
   window.themeFormatMoney synchronously during their own initial setup,
   not just from later click handlers. Previously these were defined at
   the very BOTTOM of this file, which worked only by accident (nothing
   used to call themeFormatMoney until a user interaction happened well
   after the whole file had finished loading). Once a feature called it
   during initial page load, it threw "themeFormatMoney is not a function"
   -- and because that throw happened during the script's own top-level
   synchronous execution (not inside an event handler), it aborted the
   REST of this file, so the assignment at the bottom never ran and
   themeFormatMoney stayed undefined forever, breaking every later click
   too. Defining these first removes the ordering dependency entirely. */
window.themeStrings = window.themeStrings || { addToCart: 'Add to Cart', soldOut: 'Sold Out' };

window.themeFormatMoney = function (cents) {
  var format = window.themeMoneyFormat || '${{amount}}';
  var amount = (cents / 100).toFixed(2);
  var parts = amount.split('.');
  var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  var noDecimals = withCommas;
  var withDecimals = withCommas + '.' + parts[1];
  return format
    .replace('{{amount}}', withDecimals)
    .replace('{{amount_no_decimals}}', noDecimals)
    .replace('{{amount_with_comma_separator}}', withDecimals)
    .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals);
};

/* ---------- Nav drawer ---------- */
(function () {
  var drawer = document.querySelector('[data-nav-drawer]');
  var toggleBtn = document.querySelector('[data-drawer-toggle]');
  if (!drawer || !toggleBtn) return;

  var closeEls = drawer.querySelectorAll('[data-drawer-close]');

  function openDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    toggleBtn.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    toggleBtn.setAttribute('aria-expanded', 'false');
  }

  toggleBtn.addEventListener('click', openDrawer);
  closeEls.forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  drawer.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-submenu-toggle');
      var submenu = drawer.querySelector('[data-submenu="' + id + '"]');
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      if (submenu) submenu.hidden = isOpen;
    });
  });
})();

/* ---------- Search popover ---------- */
(function () {
  var popover = document.querySelector('[data-search-popover]');
  var toggleBtn = document.querySelector('[data-search-toggle]');
  if (!popover || !toggleBtn) return;

  var closeEls = popover.querySelectorAll('[data-search-close]');
  var input = popover.querySelector('[data-search-input]');

  function open() {
    popover.setAttribute('aria-hidden', 'false');
    toggleBtn.setAttribute('aria-expanded', 'true');
    if (input) setTimeout(function () { input.focus(); }, 50);
  }
  function close() {
    popover.setAttribute('aria-hidden', 'true');
    toggleBtn.setAttribute('aria-expanded', 'false');
  }

  toggleBtn.addEventListener('click', open);
  closeEls.forEach(function (el) { el.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();

/* ---------- Product gallery ---------- */
(function () {
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-gallery-thumb');
        gallery.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-gallery-slide') === id);
        });
        thumbs.forEach(function (t) { t.classList.toggle('is-selected', t === thumb); t.classList.toggle('is-active', t === thumb); });
      });
    });
  });
})();

/* ---------- Finishing options modal (banners, signage) ---------- */
(function () {
  document.querySelectorAll('[data-finishing-option]').forEach(function (wrapper) {
    var openBtn = wrapper.querySelector('[data-finishing-open]');
    var modal = wrapper.querySelector('[data-finishing-modal]');
    if (!openBtn || !modal) return;

    var closeEls = modal.querySelectorAll('[data-finishing-close]');
    var applyBtn = modal.querySelector('[data-finishing-apply]');
    var summaryText = wrapper.querySelector('[data-finishing-summary-text]');
    var finishingInput = wrapper.querySelector('[data-finishing-input]');
    var polePocketsInput = wrapper.querySelector('[data-pole-pockets-input]');
    var windSlitsInput = wrapper.querySelector('[data-wind-slits-input]');

    var selected = {
      finishing: finishingInput ? finishingInput.value : 'Hemmed + Grommets',
      polePockets: polePocketsInput ? polePocketsInput.value : 'None',
      windSlits: windSlitsInput ? windSlitsInput.value : 'No'
    };

    function open() {
      modal.setAttribute('aria-hidden', 'false');
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
    }

    openBtn.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
    });

    function wireGroup(attr, key) {
      modal.querySelectorAll('[data-' + attr + '-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          modal.querySelectorAll('[data-' + attr + '-value]').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          selected[key] = btn.getAttribute('data-' + attr + '-value');
        });
      });
    }
    wireGroup('finishing', 'finishing');
    wireGroup('pole-pockets', 'polePockets');
    wireGroup('wind-slits', 'windSlits');

    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        if (finishingInput) finishingInput.value = selected.finishing;
        if (polePocketsInput) polePocketsInput.value = selected.polePockets;
        if (windSlitsInput) windSlitsInput.value = selected.windSlits;
        if (summaryText) {
          var pole = selected.polePockets === 'None' ? 'No Pole Pockets' : selected.polePockets + ' Pole Pockets';
          var wind = selected.windSlits === 'Yes' ? 'Wind Slits' : 'No Wind Slits';
          summaryText.textContent = selected.finishing + ' · ' + pole + ' · ' + wind;
        }
        close();
      });
    }
  });
})();

/* ---------- Turnaround "Understanding Turnaround Times" info modal ---------- */
(function () {
  document.querySelectorAll('[data-turnaround]').forEach(function (wrapper) {
    var openBtn = wrapper.querySelector('[data-turnaround-info-open]');
    var modal = wrapper.querySelector('[data-turnaround-info-modal]');
    if (!openBtn || !modal) return;

    var closeEls = modal.querySelectorAll('[data-turnaround-info-close]');

    function open() {
      modal.setAttribute('aria-hidden', 'false');
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
    }

    openBtn.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
    });
  });
})();

/* ---------- Simple "Upload Artwork" button next to Add to Cart (banners, signage) ---------- */
(function () {
  document.querySelectorAll('[data-simple-artwork-input]').forEach(function (input) {
    var label = input.id ? document.querySelector('label[for="' + input.id + '"]') : null;
    var textEl = label ? label.querySelector('[data-artwork-upload-text]') : null;
    input.addEventListener('change', function () {
      if (textEl) textEl.textContent = input.files[0] ? input.files[0].name : 'Upload Artwork';
    });
  });
})();

/* ---------- Product form: variant selection, quantity, add to cart ---------- */
(function () {
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantIdInput = form.querySelector('[data-product-form-variant-id]');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var submitText = form.querySelector('[data-add-to-cart-text]');
    var quoteBtn = form.querySelector('[data-request-quote]');
    var selectedOptions = {};

    form.querySelectorAll('[data-option-index]').forEach(function (group) {
      var index = group.getAttribute('data-option-index');
      var selectedBtn = group.querySelector('.is-selected');
      if (selectedBtn) selectedOptions[index] = selectedBtn.getAttribute('data-option-value');
    });

    /* A malformed JSON blob must never throw here — an uncaught error at
       setup time would abort this whole callback and silently leave EVERY
       control on the form (price updates, add-to-cart, everything) with no
       event listeners at all. */
    function safeJsonParse(el, fallback) {
      if (!el) return fallback;
      try {
        return JSON.parse(el.textContent);
      } catch (err) {
        if (window.console && console.error) console.error('Failed to parse ' + (el.getAttribute('type') || 'json') + ' script', err);
        return fallback;
      }
    }

    var variantsScript = form.querySelector('[data-product-variants]');
    var variants = safeJsonParse(variantsScript, null);

    var variantMediaMapScript = form.querySelector('[data-variant-media-map]');
    var variantMediaMap = safeJsonParse(variantMediaMapScript, {});

    var pricingConfigScript = form.querySelector('[data-pricing-config]');
    var pricingConfig = safeJsonParse(pricingConfigScript, null);
    var productTitle = form.getAttribute('data-product-title') || '';

    var dtgVariantMap = {};
    if (pricingConfig && pricingConfig.dtgVariants) {
      pricingConfig.dtgVariants.forEach(function (v) {
        dtgVariantMap[v.tier + '|' + v.bracket] = v;
      });
    }

    /* Guard against `.product-info` ever being missing (unexpected markup,
       a form rendered outside its usual wrapper): every lookup below used
       to call `.querySelector` directly on the result of `.closest()`,
       which throws on null and would silently abort this ENTIRE setup
       function before any event listener (price updates, add to cart, the
       pricing-list toggle, everything) got attached. Falling back to the
       form itself keeps setup from ever crashing outright. */
    var productInfoEl = form.closest('.product-info') || form;

    var summaryColor = productInfoEl.querySelector('[data-summary-color]');

    var hasSizeBreakdown = form.querySelectorAll('[data-size-row]').length > 0;
    var colorOptionIndex = parseInt(form.getAttribute('data-color-option-index'), 10);
    var sizeOptionIndex = parseInt(form.getAttribute('data-size-option-index'), 10);
    var materialOptionIndex = parseInt(form.getAttribute('data-material-option-index'), 10);

    var productLayout = form.closest('.product-layout');
    var galleryEl = productLayout ? productLayout.querySelector('[data-product-gallery]') : null;
    function baseImageUrl(url) {
      if (!url) return '';
      /* Strip the query string, then strip the Shopify CDN resize suffix
         (e.g. "_1000x" or "_1000x800") that `image_url` inserts before the
         extension — without this, a resized <img src> never string-matches
         the original, un-resized URL from the variants JSON. */
      return url.split('?')[0].replace(/_\d*x\d*(?=\.[a-zA-Z0-9]+$)/, '');
    }
    function syncGalleryImage() {
      /* Gallery-image syncing is cosmetic and must never be able to block
         price/variant updates (a different concern entirely) if it hits an
         unexpected data shape — so any failure here is swallowed. */
      try {
        if (!galleryEl || !variants) return;
        /* Color takes priority (apparel); otherwise fall back to Material
           (banners, signage) — whichever option has per-variant images assigned. */
        var imageOptionIndex = (!isNaN(colorOptionIndex) && colorOptionIndex >= 0)
          ? colorOptionIndex
          : ((!isNaN(materialOptionIndex) && materialOptionIndex >= 0) ? materialOptionIndex : -1);
        if (imageOptionIndex < 0) return;
        var imageValue = selectedOptions[imageOptionIndex];
        var match = variants.find(function (v) { return v.options[imageOptionIndex] === imageValue; });
        if (!match) return;
        /* `variant.featured_media.id` (rendered into data-variant-media-map by
           the section, since `product.variants | json` doesn't reliably expose
           it) is in the SAME id space as `media.id` (data-gallery-slide/thumb
           below) — this is the same variant<->media matching Shopify's own
           Dawn theme uses. `featured_image.id` is a different, legacy id space
           and does NOT match `media.id`; don't use it here. */
        var targetMediaId = variantMediaMap[String(match.id)];
        var targetSrc = match.featured_image ? baseImageUrl(match.featured_image.src) : '';
        var slides = galleryEl.querySelectorAll('[data-gallery-slide]');
        var matchedSlide = null;
        slides.forEach(function (slide) {
          if (targetMediaId != null && slide.getAttribute('data-gallery-slide') === String(targetMediaId)) {
            matchedSlide = slide;
            return;
          }
          if (!matchedSlide && targetSrc) {
            var img = slide.querySelector('img');
            if (img && baseImageUrl(img.getAttribute('src')) === targetSrc) matchedSlide = slide;
          }
        });
        /* Only touch active state once we've actually found the slide — an
           image mismatch (e.g. a resize service change) should leave the
           gallery as-is rather than deactivating every slide. */
        if (!matchedSlide) return;
        var matchedMediaId = matchedSlide.getAttribute('data-gallery-slide');
        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide === matchedSlide);
        });
        galleryEl.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
          thumb.classList.toggle('is-active', thumb.getAttribute('data-gallery-thumb') === matchedMediaId);
        });
      } catch (err) {
        if (window.console && console.warn) console.warn('syncGalleryImage failed', err);
      }
    }

    /* Gallery images tagged with a Size (via data-gallery-size, set in Liquid
       from the gallery_image_size block type) are filtered to only the ones
       matching the currently selected Size -- untagged images (products that
       don't use this feature) are left alone entirely. */
    function syncGallerySizeFilter() {
      try {
        if (!galleryEl) return;
        var taggedSlides = galleryEl.querySelectorAll('[data-gallery-slide][data-gallery-size]');
        if (!taggedSlides.length) return;
        /* Read the current Size straight off the highlighted button rather
           than only trusting sizeOptionIndex -- that's the same source of
           truth the customer sees on screen, so it can't silently drift out
           of sync with a numeric option index computed elsewhere (e.g. when
           another option is added/reordered ahead of Size). Falls back to
           the index-based lookup if that button can't be found for some
           reason. */
        var sizeBtn = form.querySelector('[data-option-name="Size"] .is-selected[data-option-value]');
        var currentSize = sizeBtn
          ? sizeBtn.getAttribute('data-option-value')
          : ((!isNaN(sizeOptionIndex) && sizeOptionIndex >= 0) ? selectedOptions[sizeOptionIndex] : null);
        if (!currentSize) return;
        var slides = galleryEl.querySelectorAll('[data-gallery-slide]');
        var thumbs = galleryEl.querySelectorAll('[data-gallery-thumb]');
        slides.forEach(function (slide) {
          var tag = slide.getAttribute('data-gallery-size');
          slide.hidden = !!tag && tag !== currentSize;
        });
        thumbs.forEach(function (thumb) {
          var tag = thumb.getAttribute('data-gallery-size');
          thumb.hidden = !!tag && tag !== currentSize;
        });
        var activeSlide = galleryEl.querySelector('[data-gallery-slide].is-active');
        if (!activeSlide || activeSlide.hidden) {
          var firstVisibleSlide = null;
          slides.forEach(function (slide) {
            if (!firstVisibleSlide && !slide.hidden) firstVisibleSlide = slide;
          });
          if (firstVisibleSlide) {
            var visibleId = firstVisibleSlide.getAttribute('data-gallery-slide');
            slides.forEach(function (slide) { slide.classList.toggle('is-active', slide === firstVisibleSlide); });
            thumbs.forEach(function (thumb) { thumb.classList.toggle('is-active', thumb.getAttribute('data-gallery-thumb') === visibleId); });
          }
        }
      } catch (err) {
        if (window.console && console.warn) console.warn('syncGallerySizeFilter failed', err);
      }
    }

    /* Price breakdown by size (banners, signage): lists every fixed size's
       real price for the other currently-selected options (e.g. Material),
       the same "View pricing list" pattern used on sticker products. */
    function renderSizePricingTable() {
      var rowsEl = form.querySelector('[data-pricing-table-rows]');
      if (!rowsEl || !variants || isNaN(sizeOptionIndex) || sizeOptionIndex < 0) return;
      var seen = {};
      var sizeValues = [];
      variants.forEach(function (v) {
        var val = v.options[sizeOptionIndex];
        if (!val || /^Custom \(up to/i.test(val) || seen[val]) return;
        seen[val] = true;
        sizeValues.push(val);
      });
      var currentSize = selectedOptions[sizeOptionIndex];
      rowsEl.innerHTML = sizeValues.map(function (sizeVal) {
        var match = variants.find(function (v) {
          return v.options[sizeOptionIndex] === sizeVal && Object.keys(selectedOptions).every(function (i) {
            return parseInt(i, 10) === sizeOptionIndex || v.options[parseInt(i, 10)] === selectedOptions[i];
          });
        });
        if (!match) return '';
        var isActive = sizeVal === currentSize;
        return '<div class="pricing-table__row' + (isActive ? ' is-active' : '') + '">' +
          '<span>' + sizeVal + '</span>' +
          '<span>' + window.themeFormatMoney(match.price) + '</span>' +
          '</div>';
      }).join('');
    }

    var sizePricingToggle = form.querySelector('[data-pricing-toggle]');
    var sizePricingTable = form.querySelector('[data-pricing-table]');
    if (sizePricingToggle && sizePricingTable) {
      sizePricingToggle.addEventListener('click', function () {
        var isOpen = sizePricingToggle.getAttribute('aria-expanded') === 'true';
        sizePricingToggle.setAttribute('aria-expanded', String(!isOpen));
        sizePricingTable.hidden = isOpen;
        var textEl = sizePricingToggle.querySelector('[data-pricing-toggle-text]');
        if (textEl) textEl.previousSibling.textContent = isOpen ? 'View pricing list ' : 'Hide pricing list ';
      });
    }

    /* Custom size: some non-apparel products (e.g. banners) offer a "Custom"
       size pill that isn't a real variant itself — instead there are real
       "Custom (up to W x H)" variants (per material) that we auto-match the
       customer's exact dimensions to, so the price shown always matches a
       real variant price rather than a synthetic estimate. */
    function parseCustomBracket(str) {
      var m = /([\d.]+)\s*(['"])\s*x\s*([\d.]+)\s*['"]/i.exec(str || '');
      if (!m) return null;
      var w = parseFloat(m[1]);
      var h = parseFloat(m[3]);
      return { w: w, h: h, area: w * h, unit: m[2] };
    }

    function getCustomBrackets(optionIndex) {
      var seen = {};
      var out = [];
      if (!variants) return out;
      variants.forEach(function (v) {
        var val = v.options[optionIndex];
        if (!val || !/^Custom \(up to/i.test(val)) return;
        if (seen[val]) return;
        seen[val] = true;
        var s = parseCustomBracket(val);
        if (s) out.push({ value: val, w: s.w, h: s.h, area: s.area, unit: s.unit });
      });
      out.sort(function (a, b) { return a.area - b.area; });
      return out;
    }

    function matchCustomBracket(optionIndex, width, height) {
      if (!width || !height) return null;
      var brackets = getCustomBrackets(optionIndex);
      for (var i = 0; i < brackets.length; i++) {
        var b = brackets[i];
        var fits = (width <= b.w && height <= b.h) || (width <= b.h && height <= b.w);
        if (fits) return b.value;
      }
      return null;
    }

    function buildQuoteMailto(width, height, unit) {
      var subject = 'Custom size quote request: ' + productTitle;
      var body = 'Product: ' + productTitle +
        '\nCustom size: ' + width + unit + ' x ' + height + unit +
        '\n\nThis size is larger than what’s offered automatically online — please send me pricing.';
      return 'mailto:info@instagarment.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    }

    function updateCustomSize(group, index) {
      var widthInput = group.querySelector('[data-custom-width]');
      var heightInput = group.querySelector('[data-custom-height]');
      var noteEl = group.querySelector('[data-custom-note]');
      var dimsInput = group.querySelector('[data-custom-dimensions-input]');
      if (!widthInput || !heightInput) return;

      var width = parseFloat(widthInput.value) || 0;
      var height = parseFloat(heightInput.value) || 0;
      var optionIndex = parseInt(index, 10);
      var matched = matchCustomBracket(optionIndex, width, height);
      var unit = (getCustomBrackets(optionIndex)[0] || {}).unit || "'";

      if (!matched) {
        selectedOptions[index] = null;
        if (noteEl) {
          noteEl.hidden = false;
          noteEl.textContent = (width && height)
            ? 'That size is larger than we offer automatically online. Click "Request a Custom Quote" and we’ll send you pricing.'
            : 'Enter your exact width and height — we’ll automatically match you to the right size and price.';
        }
        if (submitBtn) submitBtn.hidden = true;
        if (quoteBtn) {
          quoteBtn.hidden = !(width && height);
          if (width && height) quoteBtn.href = buildQuoteMailto(width, height, unit);
        }
        if (dimsInput) { dimsInput.value = ''; dimsInput.name = ''; }
        var priceEl = productInfoEl.querySelector('.product-info__price');
        if (priceEl) priceEl.innerHTML = '<span class="price">Enter size for price</span>';
        if (summaryUnitPriceEl) summaryUnitPriceEl.innerHTML = '<span class="price">&mdash;</span>';
        if (summaryPriceEl && !hasSizeBreakdown) summaryPriceEl.innerHTML = '<span class="price">&mdash;</span>';
        return;
      }

      if (noteEl) {
        noteEl.hidden = false;
        noteEl.textContent = 'Matched to ' + matched + ' — the smallest size that fits, at that size’s price.';
      }
      if (quoteBtn) quoteBtn.hidden = true;
      if (submitBtn) submitBtn.hidden = false;
      if (dimsInput) {
        dimsInput.name = 'properties[Custom Dimensions]';
        dimsInput.value = width + unit + ' x ' + height + unit;
      }
      if (summarySizeEl) summarySizeEl.textContent = matched;
      selectedOptions[index] = matched;
      updateVariant();
    }

    form.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.getAttribute('data-option-index');
        var group = form.querySelector('[data-option-index="' + index + '"]');
        group.querySelectorAll('[data-option-value]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var labelValueEl = group.querySelector('[data-option-selected-value]');
        if (labelValueEl) labelValueEl.textContent = btn.getAttribute('data-option-value');
        if (summaryColor && group.getAttribute('data-option-name') === 'Color') {
          summaryColor.textContent = btn.getAttribute('data-option-value');
        }
        if (summarySizeEl && group.getAttribute('data-option-name') === 'Size') {
          summarySizeEl.textContent = btn.getAttribute('data-option-value');
        }

        var fieldsEl = group.querySelector('[data-custom-fields]');
        var noteEl = group.querySelector('[data-custom-note]');
        var dimsInput = group.querySelector('[data-custom-dimensions-input]');

        if (btn.hasAttribute('data-option-custom')) {
          selectedOptions[index] = null;
          if (fieldsEl) fieldsEl.hidden = false;
          updateCustomSize(group, index);
        } else {
          if (fieldsEl) fieldsEl.hidden = true;
          if (noteEl) noteEl.hidden = true;
          if (dimsInput) { dimsInput.value = ''; dimsInput.name = ''; }
          if (quoteBtn) quoteBtn.hidden = true;
          if (submitBtn) submitBtn.hidden = false;
          selectedOptions[index] = btn.getAttribute('data-option-value');
        }

        /* Price/variant updates must never be able to block the gallery
           sync below -- an error in one variant-matching helper (e.g. an
           add-on or template-download helper that assumes options it
           doesn't have) must not leave the gallery stuck on the
           previously active image. */
        try {
          if (hasSizeBreakdown) {
            syncSizeBreakdown();
          } else {
            updateVariant();
          }
        } catch (err) {
          if (window.console && console.error) console.error('Variant/price update failed', err);
        }
        syncGalleryImage();
        syncGallerySizeFilter();
      });
    });

    form.querySelectorAll('[data-custom-width], [data-custom-height]').forEach(function (input) {
      var group = input.closest('[data-option-index]');
      var index = group.getAttribute('data-option-index');
      input.addEventListener('input', function () { updateCustomSize(group, index); });
    });

    /* Size breakdown (per-size quantity grid) */
    var summaryBreakdown = productInfoEl.querySelector('[data-summary-breakdown]');
    var summaryQuantityBreakdown = productInfoEl.querySelector('[data-summary-quantity]');
    var breakdownTotalEl = form.querySelector('[data-size-breakdown-total]');
    var summaryPriceEl = productInfoEl.querySelector('[data-summary-price]');
    var summaryUnitPriceEl = productInfoEl.querySelector('[data-summary-unit-price]');
    var summarySizeEl = productInfoEl.querySelector('[data-summary-size]');
    var currentUnitPrice = parseInt(form.getAttribute('data-initial-price'), 10) || 0;

    /* Add-on accessories (e.g. Event Tent Full Wall / Half Wall): each is a
       real, separately-priced product added as its own cart line item on
       submit, so the additive total shown here always matches what
       actually gets charged at checkout. An add-on can carry its own
       per-size variants (Full Wall costs more on a 20ft tent than a 10ft
       one) -- resolveAddonVariant() re-picks the matching variant every
       time the main product's Size selection changes. */
    var addonRows = Array.prototype.map.call(form.querySelectorAll('[data-addon-checkbox]'), function (cb) {
      var variantsScript = cb.parentElement.querySelector('[data-addon-variants]');
      return {
        checkbox: cb,
        priceDisplay: cb.parentElement.querySelector('[data-addon-price-display]'),
        variants: safeJsonParse(variantsScript, [])
      };
    });
    var summaryAddons = productInfoEl.querySelector('[data-summary-addons]');

    /* The add-on's own gallery slide (if the merchant picked one) lives
       alongside the normal product/variant images, keyed the same way
       (data-gallery-slide). Capture whichever slide is active before any
       add-on is checked so unchecking can restore it. */
    var defaultGallerySlideId = null;
    if (galleryEl) {
      var initialSlide = galleryEl.querySelector('[data-gallery-slide].is-active') || galleryEl.querySelector('[data-gallery-slide]');
      if (initialSlide) defaultGallerySlideId = initialSlide.getAttribute('data-gallery-slide');
    }

    function activateGallerySlideById(id) {
      if (!galleryEl || !id) return false;
      var slides = galleryEl.querySelectorAll('[data-gallery-slide]');
      var matched = null;
      slides.forEach(function (slide) {
        if (slide.getAttribute('data-gallery-slide') === id) matched = slide;
      });
      if (!matched) return false;
      slides.forEach(function (slide) { slide.classList.toggle('is-active', slide === matched); });
      galleryEl.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-gallery-thumb') === id);
      });
      return true;
    }

    function syncAddonGalleryImage() {
      /* Most-recently-checked add-on with a gallery image wins; falls back
         to whichever other checked add-on has one, then to the product's
         own default image once nothing with a picture is checked. */
      var activeRow = null;
      for (var i = addonRows.length - 1; i >= 0; i--) {
        var row = addonRows[i];
        var imageId = row.checkbox.getAttribute('data-gallery-image-id');
        if (row.checkbox.checked && imageId) { activeRow = row; break; }
      }
      if (activeRow) {
        activateGallerySlideById(activeRow.checkbox.getAttribute('data-gallery-image-id'));
      } else {
        activateGallerySlideById(defaultGallerySlideId);
      }
    }

    function resolveAddonVariant(row) {
      if (!row.variants.length) return null;
      if (sizeOptionIndex >= 0) {
        var currentSize = selectedOptions[sizeOptionIndex];
        var match = row.variants.find(function (v) { return v.size === currentSize; });
        if (match) return match;
      }
      return row.variants[0];
    }

    function getAddonTotal() {
      var total = 0;
      addonRows.forEach(function (row) {
        if (!row.checkbox.checked) return;
        var variant = resolveAddonVariant(row);
        if (variant) total += variant.price;
      });
      return total;
    }

    function syncAddonPriceLabels() {
      addonRows.forEach(function (row) {
        var variant = resolveAddonVariant(row);
        if (variant && row.priceDisplay) row.priceDisplay.textContent = '+' + window.themeFormatMoney(variant.price);
      });
    }

    function syncAddonSummary() {
      if (summaryAddons) {
        var labels = [];
        addonRows.forEach(function (row) {
          if (row.checkbox.checked) labels.push(row.checkbox.getAttribute('data-addon-label'));
        });
        summaryAddons.textContent = labels.length ? labels.join(', ') : 'None';
      }
      updateNonBreakdownTotal();
    }

    addonRows.forEach(function (row) {
      row.checkbox.addEventListener('change', function () {
        syncAddonSummary();
        syncAddonGalleryImage();
      });
    });

    /* Non-breakdown products (a single Add to Cart line, e.g. banners/signage)
       show both a per-unit price and a Total Price that tracks quantity —
       size-breakdown products compute their own total in syncSizeBreakdown(). */
    function updateNonBreakdownTotal() {
      if (!summaryPriceEl || hasSizeBreakdown) return;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      summaryPriceEl.innerHTML = '<span class="price"><span class="price__current">' + window.themeFormatMoney((currentUnitPrice + getAddonTotal()) * qty) + '</span></span>';
    }

    function collectSizeRows() {
      return Array.prototype.map.call(form.querySelectorAll('[data-size-row]'), function (row) {
        var input = row.querySelector('[data-size-qty-input]');
        return { size: row.getAttribute('data-size-value'), qty: Math.max(0, parseInt(input.value, 10) || 0) };
      });
    }

    function bracketIndex(qty) {
      var breaks = pricingConfig.breaks;
      var idx = 0;
      for (var i = 0; i < breaks.length; i++) {
        if (qty >= breaks[i]) idx = i;
      }
      return idx;
    }

    function garmentUnitPrice() {
      if (!variants) return 0;
      var colorValue = selectedOptions[colorOptionIndex];
      var match = variants.find(function (v) { return colorOptionIndex < 0 || v.options[colorOptionIndex] === colorValue; });
      return match ? match.price : 0;
    }

    /* Looks up the real Direct-to-Garment Printing variant(s) for the
       selected placement at the given total order quantity, so the price
       shown here always matches what gets added to cart. */
    function getPrintTierEntries(totalQty) {
      if (!pricingConfig || !selectedPlacementId || !pricingConfig.placements[selectedPlacementId]) return [];
      var placement = pricingConfig.placements[selectedPlacementId];
      var bracket = pricingConfig.bracketLabels[bracketIndex(totalQty || 1)];
      var entries = [];
      var front = dtgVariantMap[placement.tier + '|' + bracket];
      if (front) entries.push(front);
      if (placement.backTier) {
        var back = dtgVariantMap[placement.backTier + '|' + bracket];
        if (back) entries.push(back);
      }
      return entries;
    }

    function getBreakdownUnitPrice(totalQty) {
      var printEntries = getPrintTierEntries(totalQty);
      var printTotal = printEntries.reduce(function (sum, e) { return sum + e.price; }, 0);
      return garmentUnitPrice() + printTotal;
    }

    /* Live per-size stock, mirrored from S&S Activewear's NV (Reno) warehouse
       into each variant's inventory_quantity by the scheduled sync script
       (scripts/ss-activewear-sync/sync.mjs) -- this just displays whatever
       Shopify already has, keyed to the color currently selected above. */
    function updateSizeStockLabels() {
      if (!variants || colorOptionIndex < 0) return;
      var colorValue = selectedOptions[colorOptionIndex];
      form.querySelectorAll('[data-size-row]').forEach(function (row) {
        var stockEl = row.querySelector('[data-size-stock]');
        if (!stockEl) return;
        var sizeValue = row.getAttribute('data-size-value');
        var match = variants.find(function (v) {
          var colorOk = colorOptionIndex < 0 || v.options[colorOptionIndex] === colorValue;
          var sizeOk = sizeOptionIndex < 0 || v.options[sizeOptionIndex] === sizeValue;
          return colorOk && sizeOk;
        });
        var qty = match && typeof match.inventory_quantity === 'number' ? match.inventory_quantity : null;
        if (qty === null) {
          stockEl.textContent = '';
          stockEl.classList.remove('size-breakdown__stock--out');
        } else if (qty <= 0) {
          stockEl.textContent = 'Out of stock';
          stockEl.classList.add('size-breakdown__stock--out');
        } else {
          stockEl.textContent = qty + ' in stock';
          stockEl.classList.remove('size-breakdown__stock--out');
        }
      });
    }

    function syncSizeBreakdown() {
      updateSizeStockLabels();
      var rows = collectSizeRows();
      var total = rows.reduce(function (sum, r) { return sum + r.qty; }, 0);
      if (breakdownTotalEl) breakdownTotalEl.textContent = total;
      if (summaryQuantityBreakdown) summaryQuantityBreakdown.textContent = total;
      if (summaryBreakdown) {
        var active = rows.filter(function (r) { return r.qty > 0; });
        summaryBreakdown.textContent = active.length ? active.map(function (r) { return r.size + ':' + r.qty; }).join(', ') : '—';
      }
      if (summaryPriceEl) {
        var unitPrice = getBreakdownUnitPrice(total);
        summaryPriceEl.innerHTML = '<span class="price"><span class="price__current">' + window.themeFormatMoney(unitPrice * total) + '</span></span>';
      }
      if (submitBtn) submitBtn.disabled = total === 0;
    }

    if (hasSizeBreakdown) {
      form.querySelectorAll('[data-size-row]').forEach(function (row) {
        var input = row.querySelector('[data-size-qty-input]');
        var decreaseBtn = row.querySelector('[data-size-qty-decrease]');
        var increaseBtn = row.querySelector('[data-size-qty-increase]');
        decreaseBtn.addEventListener('click', function () {
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
          syncSizeBreakdown();
        });
        increaseBtn.addEventListener('click', function () {
          input.value = (parseInt(input.value, 10) || 0) + 1;
          syncSizeBreakdown();
        });
        input.addEventListener('input', syncSizeBreakdown);
      });
    }

    /* Print placement picker */
    var placementInput = form.querySelector('[data-print-placement-input]');
    var placementSelected = form.querySelector('[data-print-placement-selected]');
    var summaryPlacement = productInfoEl.querySelector('[data-summary-placement]');
    var initialPlacementBtn = form.querySelector('[data-print-placement-value].is-selected');
    var selectedPlacementId = initialPlacementBtn ? initialPlacementBtn.getAttribute('data-print-placement-id') : null;
    form.querySelectorAll('[data-print-placement-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        form.querySelectorAll('[data-print-placement-value]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var value = btn.getAttribute('data-print-placement-value');
        selectedPlacementId = btn.getAttribute('data-print-placement-id');
        if (placementInput) placementInput.value = value;
        if (placementSelected) placementSelected.textContent = value;
        if (summaryPlacement) summaryPlacement.textContent = value;
        if (hasSizeBreakdown) syncSizeBreakdown();
      });
    });

    /* Turnaround picker */
    var turnaroundInput = form.querySelector('[data-turnaround-input]');
    var turnaroundSelected = form.querySelector('[data-turnaround-selected]');
    var summaryTurnaround = productInfoEl.querySelector('[data-summary-turnaround]');
    form.querySelectorAll('[data-turnaround-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        form.querySelectorAll('[data-turnaround-value]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var value = btn.getAttribute('data-turnaround-value');
        if (turnaroundInput) turnaroundInput.value = value;
        if (turnaroundSelected) turnaroundSelected.textContent = value;
        if (summaryTurnaround) summaryTurnaround.textContent = value;
      });
    });

    /* Template download menu: toggle open/closed, and show only the files
       whose size_label matches the currently selected Size option value.
       syncTemplateDownloadLinks is declared here (outer scope) so
       updateVariant() below can call it unconditionally; it stays a no-op
       when the product has no template_file blocks. */
    var syncTemplateDownloadLinks = function () {};
    var templateDownloadGroup = form.querySelector('[data-template-download-group]');
    if (templateDownloadGroup) {
      var templateDownloadToggle = templateDownloadGroup.querySelector('[data-template-download-toggle]');
      var templateDownloadMenu = templateDownloadGroup.querySelector('[data-template-download-menu]');
      var templateDownloadLinks = templateDownloadGroup.querySelectorAll('[data-template-size]');
      function closeTemplateDownloadMenu() {
        if (!templateDownloadMenu) return;
        templateDownloadMenu.hidden = true;
        if (templateDownloadToggle) templateDownloadToggle.setAttribute('aria-expanded', 'false');
      }
      if (templateDownloadToggle && templateDownloadMenu) {
        templateDownloadToggle.addEventListener('click', function () {
          var isOpen = !templateDownloadMenu.hidden;
          templateDownloadMenu.hidden = isOpen;
          templateDownloadToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        });
        document.addEventListener('click', function (e) {
          if (!templateDownloadGroup.contains(e.target)) closeTemplateDownloadMenu();
        });
      }
      syncTemplateDownloadLinks = function () {
        if (isNaN(sizeOptionIndex)) return;
        var currentSize = selectedOptions[sizeOptionIndex];
        templateDownloadLinks.forEach(function (link) {
          link.hidden = link.getAttribute('data-template-size') !== currentSize;
        });
      };
      syncTemplateDownloadLinks();
    }

    /* Base: a free cosmetic choice with no price impact, so it's a plain
       order property — not tied to variant matching like data-option-value is. */
    var baseInput = form.querySelector('[data-base-input]');
    form.querySelectorAll('[data-base-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        form.querySelectorAll('[data-base-value]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        if (baseInput) baseInput.value = btn.getAttribute('data-base-value');
      });
    });

    /* Reinforced strip color: a free cosmetic choice with no price impact,
       so it's a plain order property — not tied to variant matching like
       data-option-value is. */
    var stripColorInput = form.querySelector('[data-strip-color-input]');
    form.querySelectorAll('[data-strip-color-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        form.querySelectorAll('[data-strip-color-value]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        if (stripColorInput) stripColorInput.value = btn.getAttribute('data-strip-color-value');
        var stripImageId = btn.getAttribute('data-gallery-image-id');
        if (stripImageId) activateGallerySlideById(stripImageId);
      });
    });

    /* Artwork upload (inline, not a modal; supports multiple dropzones e.g. Front/Back/Sleeve) */
    var artworkSection = form.querySelector('[data-artwork-section]');
    var artworkNotes = form.querySelector('[data-artwork-notes]');
    var artworkNotesCount = form.querySelector('[data-artwork-notes-count]');
    var artworkDropzones = form.querySelectorAll('[data-artwork-dropzone]');
    var requiredArtworkInput = null;

    function setArtworkFile(dropzone, file) {
      if (!file) return;
      dropzone.querySelector('[data-artwork-file-name]').textContent = file.name;
      dropzone.querySelector('[data-artwork-dropzone-prompt]').hidden = true;
      dropzone.querySelector('[data-artwork-file-row]').hidden = false;
    }

    function validateArtwork() {
      if (!artworkSection || !requiredArtworkInput) return true;
      if (requiredArtworkInput.files.length === 0) {
        window.alert('Please choose a file to upload for your front artwork.');
        artworkSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
      return true;
    }

    function resetArtwork() {
      if (!artworkSection) return;
      artworkDropzones.forEach(function (dropzone) {
        dropzone.querySelector('[data-artwork-dropzone-prompt]').hidden = false;
        dropzone.querySelector('[data-artwork-file-row]').hidden = true;
        dropzone.querySelector('[data-artwork-file-input]').value = '';
      });
      if (artworkNotes) {
        artworkNotes.value = '';
        artworkNotesCount.textContent = '0';
      }
    }

    artworkDropzones.forEach(function (dropzone) {
      var fileInput = dropzone.querySelector('[data-artwork-file-input]');
      if (dropzone.hasAttribute('data-artwork-required')) requiredArtworkInput = fileInput;

      fileInput.addEventListener('change', function () {
        if (fileInput.files[0]) setArtworkFile(dropzone, fileInput.files[0]);
      });

      ['dragenter', 'dragover'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          dropzone.classList.add('is-dragover');
        });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          dropzone.classList.remove('is-dragover');
        });
      });
      dropzone.addEventListener('drop', function (e) {
        var file = e.dataTransfer.files && e.dataTransfer.files[0];
        if (file) {
          fileInput.files = e.dataTransfer.files;
          setArtworkFile(dropzone, file);
        }
      });
    });

    if (artworkNotes) {
      artworkNotes.addEventListener('input', function () {
        artworkNotesCount.textContent = String(artworkNotes.value.length);
      });
    }

    renderSizePricingTable();
    if (hasSizeBreakdown) syncSizeBreakdown();
    syncGalleryImage();
    syncGallerySizeFilter();

    function updateVariant() {
      if (!variants) return;
      var match = variants.find(function (v) {
        return Object.keys(selectedOptions).every(function (i) {
          return v.options[parseInt(i, 10)] === selectedOptions[i];
        });
      });
      if (!match) return;
      variantIdInput.value = match.id;
      var html = '<span class="price__current">' + window.themeFormatMoney(match.price) + '</span>';
      if (match.compare_at_price > match.price) {
        html = '<span class="price price--on-sale">' + html +
          '<span class="price__compare">' + window.themeFormatMoney(match.compare_at_price) + '</span></span>';
      } else {
        html = '<span class="price">' + html + '</span>';
      }
      var priceEl = productInfoEl.querySelector('.product-info__price');
      if (priceEl) priceEl.innerHTML = html;
      currentUnitPrice = match.price;
      if (summaryUnitPriceEl) summaryUnitPriceEl.innerHTML = html;
      syncAddonPriceLabels();
      syncAddonGalleryImage();
      syncTemplateDownloadLinks();
      updateNonBreakdownTotal();
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        if (submitText) submitText.textContent = match.available ? window.themeStrings.addToCart : window.themeStrings.soldOut;
      }
      renderSizePricingTable();
    }

    var qtyInput = form.querySelector('[data-quantity-input]');
    var decreaseBtn = form.querySelector('[data-quantity-decrease]');
    var increaseBtn = form.querySelector('[data-quantity-increase]');
    var summaryQuantity = productInfoEl.querySelector('[data-summary-quantity]');
    function syncQuantitySummary() {
      if (summaryQuantity) summaryQuantity.textContent = qtyInput.value;
      updateNonBreakdownTotal();
    }
    if (qtyInput && decreaseBtn && increaseBtn) {
      decreaseBtn.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = val;
        syncQuantitySummary();
      });
      increaseBtn.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        syncQuantitySummary();
      });
      qtyInput.addEventListener('input', syncQuantitySummary);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (hasSizeBreakdown) {
        var rows = collectSizeRows().filter(function (r) { return r.qty > 0; });
        if (rows.length === 0) {
          window.alert('Please enter a quantity for at least one size.');
          return;
        }
        if (!validateArtwork()) return;
        if (!window.themeCart || !window.themeCart.addMultiple) return;

        var colorValue = selectedOptions[colorOptionIndex];
        var baseFormData = new FormData(form);
        baseFormData.delete('id');
        baseFormData.delete('quantity');

        var lineFormDatas = [];
        var missingVariant = false;
        rows.forEach(function (r) {
          var match = variants.find(function (v) {
            return v.options[colorOptionIndex] === colorValue && v.options[sizeOptionIndex] === r.size;
          });
          if (!match) { missingVariant = true; return; }
          var fd = new FormData();
          baseFormData.forEach(function (value, key) { fd.append(key, value); });
          fd.set('id', match.id);
          fd.set('quantity', r.qty);
          lineFormDatas.push(fd);
        });
        if (missingVariant) {
          window.alert('Some selected sizes are not available in this color.');
          return;
        }

        /* Add the real print-service line(s) so checkout actually charges
           the tiered print price shown in the Pricing Summary. */
        var totalQty = rows.reduce(function (sum, r) { return sum + r.qty; }, 0);
        var printEntries = getPrintTierEntries(totalQty);
        printEntries.forEach(function (entry) {
          var dtgFd = new FormData();
          dtgFd.append('id', entry.id);
          dtgFd.append('quantity', totalQty);
          dtgFd.append('properties[Print Service For]', productTitle);
          dtgFd.append('properties[Placement]', placementInput ? placementInput.value : '');
          lineFormDatas.push(dtgFd);
        });

        submitBtn.classList.add('is-loading');
        submitBtn.disabled = true;
        window.themeCart.addMultiple(lineFormDatas).then(function () {
          submitBtn.classList.remove('is-loading');
          resetArtwork();
          form.querySelectorAll('[data-size-qty-input]').forEach(function (input) { input.value = 0; });
          syncSizeBreakdown();
        }).catch(function () {
          submitBtn.classList.remove('is-loading');
          submitBtn.disabled = false;
        });
        return;
      }

      if (!validateArtwork()) return;
      if (!window.themeCart) return;

      var checkedAddonRows = addonRows.filter(function (row) { return row.checkbox.checked; });

      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;

      if (checkedAddonRows.length > 0 && window.themeCart.addMultiple) {
        var addonQty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        var lineFormDatas = [new FormData(form)];
        checkedAddonRows.forEach(function (row) {
          var variant = resolveAddonVariant(row);
          if (!variant) return;
          var addonFd = new FormData();
          addonFd.append('id', variant.id);
          addonFd.append('quantity', addonQty);
          addonFd.append('properties[Add-On For]', productTitle);
          lineFormDatas.push(addonFd);
        });
        window.themeCart.addMultiple(lineFormDatas).then(function () {
          submitBtn.classList.remove('is-loading');
          submitBtn.disabled = false;
          resetArtwork();
        }).catch(function () {
          submitBtn.classList.remove('is-loading');
          submitBtn.disabled = false;
        });
        return;
      }

      window.themeCart.add(new FormData(form)).then(function () {
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;
        resetArtwork();
      }).catch(function () {
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;
      });
    });
  });
})();

/* ---------- Collection sorting ---------- */
(function () {
  var select = document.querySelector('[data-collection-sort]');
  if (!select) return;
  select.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.href = url.toString();
  });
})();

/* ---------- Product recommendations ---------- */
(function () {
  var el = document.querySelector('[data-product-recommendations]');
  if (!el) return;
  fetch(el.getAttribute('data-url'))
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var section = doc.querySelector('.product-recommendations');
      if (section) el.replaceWith(section);
    })
    .catch(function () {});
})();
